<template>
    <div class="page-container">
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <!-- Top Bar -->
        <div class="top-bar">
            <div class="top-bar-left">
                <h2 class="page-title">
                    <i class="tim-icons icon-chart-pie-36"></i>
                    {{ $t('admin.dashboard.title') }}
                </h2>
            </div>
        </div>

        <!-- Stats Cards -->
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-icon bg-blue">
                    <i class="tim-icons icon-bank"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.totalClients }}</span>
                    <span class="stat-label">{{ $t('admin.dashboard.totalClients') }}</span>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon bg-green">
                    <i class="tim-icons icon-check-2"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.activeClients }}</span>
                    <span class="stat-label">{{ $t('admin.dashboard.activeClients') }}</span>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon bg-orange">
                    <i class="tim-icons icon-time-alarm"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.trialClients }}</span>
                    <span class="stat-label">Na trialu</span>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon bg-purple">
                    <i class="tim-icons icon-tv-2"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.totalEsirs }}</span>
                    <span class="stat-label">{{ $t('admin.dashboard.totalEsirs') }}</span>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon bg-teal">
                    <i class="tim-icons icon-square-pin"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.totalLocations }}</span>
                    <span class="stat-label">{{ $t('admin.dashboard.totalLocations') }}</span>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon bg-pink">
                    <i class="tim-icons icon-single-02"></i>
                </div>
                <div class="stat-info">
                    <span class="stat-value">{{ stats.totalUsers }}</span>
                    <span class="stat-label">{{ $t('admin.dashboard.totalUsers') }}</span>
                </div>
            </div>
        </div>

        <!-- Recent Clients -->
        <div class="table-section" style="margin-top: 20px;">
            <div class="section-header">
                <h3><i class="tim-icons icon-bank"></i> {{ $t('admin.dashboard.recentClients') }}</h3>
                <base-button type="primary" size="sm" @click="$router.push('/admin/clients')">
                    Svi klijenti <i class="tim-icons icon-minimal-right"></i>
                </base-button>
            </div>
            <div class="table-container">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th>{{ $t('common.name') }}</th>
                            <th>{{ $t('login.tin') }}</th>
                            <th>{{ $t('common.status') }}</th>
                            <th>{{ $t('nav.esirs') }}</th>
                            <th>{{ $t('admin.clients.monthlyRevenue') }}</th>
                            <th>Trial</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="c in recentClients" :key="c.id">
                            <td class="name-cell">{{ c.name }}</td>
                            <td><span class="mono">{{ c.tin || '-' }}</span></td>
                            <td>
                                <span :class="['status-tag', 'status-' + c.subscriptionStatus.toLowerCase()]">
                                    {{ c.subscriptionStatus }}
                                </span>
                            </td>
                            <td>{{ c.esirCount }}</td>
                            <td><span class="mono">{{ formatNumber(c.monthlyTotal) }} RSD</span></td>
                            <td>
                                <span v-if="c.subscriptionStatus === 'TRIAL'">
                                    {{ c.trialDaysRemaining }} dana
                                </span>
                                <span v-else class="no-data">-</span>
                            </td>
                        </tr>
                        <tr v-if="recentClients.length === 0">
                            <td colspan="6" class="empty-row">
                                <p>{{ $t('common.noData') }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Toast -->
        <transition name="notif-fade">
            <div v-if="toast.message" :class="['toast-notif', toast.type]" @click="toast.message = ''">
                <i :class="toast.type === 'success' ? 'tim-icons icon-check-2' : 'tim-icons icon-alert-circle-exc'"></i>
                <span>{{ toast.message }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from '@/util/axiosinstance'

export default {
    name: 'AdminDashboard',
    data() {
        return {
            loading: false,
            stats: {
                totalClients: 0,
                totalLocations: 0,
                totalEsirs: 0,
                totalUsers: 0,
                activeClients: 0,
                trialClients: 0
            },
            recentClients: [],
            toast: { message: '', type: 'success' }
        }
    },
    created() {
        this.loadDashboard()
        this.loadClients()
    },
    methods: {
        loadDashboard() {
            this.loading = true
            axios.get('/api/v1/admin/dashboard').then(res => {
                this.stats = res.data
                this.loading = false
            }).catch(err => {
                this.loading = false
                this.showToast(this.$t('pos.result.error'), 'error')
            })
        },

        loadClients() {
            axios.get('/api/v1/admin/clients').then(res => {
                // Poslednjih 5, filtriraj SYSTEM
                this.recentClients = res.data
                    .filter(c => c.id !== 'SYSTEM')
                    .slice(0, 5)
            })
        },

        formatNumber(val) {
            if (!val && val !== 0) return '0'
            return Number(val).toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        showToast(message, type) {
            this.toast = { message, type }
            setTimeout(() => { this.toast = { message: '', type: 'success' } }, 3000)
        }
    }
}
</script>

<style scoped>
.page-container { padding: 0; }
.loader-container {
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255,255,255,0.7); display: flex;
    align-items: center; justify-content: center; z-index: 9999;
}
.loader {
    width: 40px; height: 40px;
    border: 4px solid #e9ecef; border-top-color: #1a73e8;
    border-radius: 50%; animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.top-bar {
    display: flex; justify-content: space-between;
    align-items: center; margin-bottom: 20px;
}
.top-bar-left { display: flex; align-items: center; gap: 10px; }
.page-title {
    margin: 0; font-size: 22px; font-weight: 700;
    color: #2c3e50; display: flex; align-items: center; gap: 8px;
}
.page-title i { color: #1a73e8; }

/* Stats */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
}
.stat-card {
    background: #ffffff; border-radius: 12px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 20px;
    display: flex; align-items: center; gap: 15px;
    transition: transform 0.2s, box-shadow 0.2s;
}
.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}
.stat-icon {
    width: 50px; height: 50px; border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
}
.stat-icon i { font-size: 22px; color: white; }
.bg-blue { background: linear-gradient(135deg, #1a73e8, #0d47a1); }
.bg-green { background: linear-gradient(135deg, #28a745, #1e7e34); }
.bg-orange { background: linear-gradient(135deg, #fd7e14, #e8590c); }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #5a32a3); }
.bg-teal { background: linear-gradient(135deg, #20c997, #0ca678); }
.bg-pink { background: linear-gradient(135deg, #e83e8c, #c2185b); }
.stat-info { display: flex; flex-direction: column; }
.stat-value { font-size: 26px; font-weight: 700; color: #2c3e50; line-height: 1; }
.stat-label { font-size: 13px; color: #6c757d; margin-top: 4px; }

/* Table */
.table-section {
    background: #ffffff; border-radius: 12px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06); overflow: hidden;
}
.section-header {
    padding: 15px 20px; display: flex;
    justify-content: space-between; align-items: center;
    border-bottom: 1px solid #e9ecef;
}
.section-header h3 {
    margin: 0; font-size: 16px; font-weight: 600;
    color: #2c3e50; display: flex; align-items: center; gap: 8px;
}
.table-container { overflow-x: auto; }
.custom-table { width: 100%; border-collapse: collapse; }
.custom-table th, .custom-table td {
    padding: 12px 15px; text-align: left;
    border-bottom: 1px solid #e9ecef;
    color: #2c3e50; font-size: 14px;
}
.custom-table th {
    background: #f8f9fa; font-weight: 600;
    font-size: 12px; text-transform: uppercase;
    letter-spacing: 0.3px; color: #495057;
}
.custom-table tbody tr:hover { background: #f1f5ff; }
.name-cell { font-weight: 600; }
.mono {
    font-family: monospace; background: #f1f3f5;
    padding: 2px 8px; border-radius: 4px; font-size: 13px;
}
.status-tag {
    padding: 3px 10px; border-radius: 10px;
    font-size: 11px; font-weight: 600; text-transform: uppercase;
}
.status-trial { background: #fff3cd; color: #856404; }
.status-active { background: #d4edda; color: #155724; }
.status-suspended { background: #f8d7da; color: #721c24; }
.status-expired { background: #e2e3e5; color: #383d41; }
.no-data { color: #adb5bd; }
.empty-row { text-align: center; padding: 30px !important; color: #6c757d; }

.toast-notif {
    position: fixed; top: 25px; right: 25px;
    padding: 12px 20px; border-radius: 10px;
    display: flex; align-items: center; gap: 8px;
    font-size: 14px; font-weight: 500;
    z-index: 100000; cursor: pointer;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15); color: white;
}
.toast-notif.success { background: #28a745; }
.toast-notif.error { background: #dc3545; }
.notif-fade-enter-active, .notif-fade-leave-active { transition: all 0.3s ease; }
.notif-fade-enter, .notif-fade-leave-to { opacity: 0; transform: translateX(50px); }

@media (max-width: 768px) {
    .stats-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
    .stats-grid { grid-template-columns: 1fr; }
}
</style>